// 更新可能な管理者定義
export const GV_DESKADMINS = ['deskadmin'];

// デスク定義（影響顧客、ケース参照可）
export const GV_DESKS = ['deskadmin','desk'];

// ダイアログサイズ
export const GV_DIALOG_SIZE = '6xl';